import React from 'react';
import PageContainer from '../common/PageContainer';
import { PageWrapper } from '../elements';
import ImageAndJoinedTime from './ImageAndJoinedTime';
import InfoForm from './InfoForm';
import DeleteEverything from './DeleteEverything';

export default function GeneralInfo(): React.ReactElement {
  return (
    <PageContainer tab={'profile'}>
      <PageWrapper>
        <ImageAndJoinedTime />
        <InfoForm />
        <DeleteEverything />
      </PageWrapper>
    </PageContainer>
  );
}
